import React, { useState, useEffect } from "react";
import styles from "../translations/Translation.module.scss";
import ClearIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import { Grid, TextField } from "@mui/material";
import TranslationsClient from "./TranslationsClient";
import { NOTNULL_OR_NOTUNDEFINED } from "../../utils/EmpUtil";

const TranslationSpecific = (props) => {
  const [language, setLanguage] = useState({});
  const [oldLanguage, setOldLanguage] = useState({});
  const [isEditable, setIsEditable] = useState(false);

  const lan = props.currentLan;

  useEffect(() => {
    setLanguage(props.language);
  }, [props.language]);

  const handleChange = (event) => {
    const updatedLanguage = { ...language };
    updatedLanguage[lan] = event.target.value;
    setLanguage(updatedLanguage);
  };

  const edit = () => {
    setIsEditable(!isEditable);
    setOldLanguage(language);
  };

  const cancel = () => {
    setIsEditable(!isEditable);
    setLanguage(oldLanguage);
  };

  const publish = () => {
    TranslationsClient.updateCurrentTranslations(
      lan,
      props.moduleKey,
      language.key,
      language[lan],
      props.userDetails.market
    );
    setIsEditable(!isEditable);
  };

  return NOTNULL_OR_NOTUNDEFINED(language[lan]) &&
    !language[lan].startsWith("{") ? (
    <div>
      <Grid container className={styles.lan}>
        <Grid item md={3} className={styles.lanDetails}>
          {language.key}
        </Grid>
        <Grid item md={3} className={styles.lanDetails}>
          {language.en}
        </Grid>
        <Grid item md={3} className={styles.lanDetails}>
          {isEditable ? (
            <TextField
              className={styles.inputFieldspecific}
              style={{ padding: "5px" }}
              type="text"
              variant="outlined"
              name="topicBox"
              multiline
              value={language[lan]}
              onChange={handleChange}
            />
          ) : (
            <Grid item md={3} className={styles.lanDetails}>
              {language[lan]}
            </Grid>
          )}
        </Grid>
        {isEditable ? (
          <Grid item md={3} className={styles.lanUpdate}>
            <DoneIcon
              fontSize="small"
              style={{ color: "green" }}
              className={styles.button_hover}
              onClick={publish}
            />
            <ClearIcon
              fontSize="small"
              style={{ color: "red" }}
              className={styles.button_hover}
              onClick={cancel}
            />
          </Grid>
        ) : (
          <Grid item md={3} className={styles.lanUpdate}>
            <EditIcon
              fontSize="small"
              color="primary"
              variant="outlined"
              className={styles.button_hover}
              onClick={edit}
            />
          </Grid>
        )}
      </Grid>
    </div>
  ) : null;
};

export default TranslationSpecific;
